export default __webpack_public_path__ + "static/media/Dance of The Degens.57654ec0.png";